import script from "./goRinSyo0067.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0067.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0067.vue?vue&type=style&index=0&id=7550aa1b&lang=scss"

const __exports__ = script;

export default __exports__